import * as ping from '@/lib/usage_ping';

export function hitwall(that: any, type: ping.SubscriptionUsage, uid: string) {
    ping.send({ type: ping.SubscriptionUsage.deckpaywall, uid});
    that.$toast.open({
        message: payMsg(type),
        type: 'success',
        duration: 5000,
        position: 'top-right'
    });
    setTimeout(() => {
        const url = `${that.$store.state.checkoutDefaultURL}&headerMsg=${encodeURI("Start a free trial today!")}&alertMsg=${encodeURI("You've reached the limit of our free tier.  Start a free trial of quizMe Plus today!")}`
        that.$router.push(url);
    }, 1000);
}

function payMsg(type: ping.SubscriptionUsage) {
    switch (type) {
        case ping.SubscriptionUsage.deckpaywall:
            return 'You have already added the maximum number of decks for our free tier.  Would you like to start a free trial?';
        case ping.SubscriptionUsage.cardpaywall:
            return 'You have already added the maximum number of cards for this deck on our free tier.  Would you like to start a free trial?';
        default:
            return 'You have hit the limit of our free tier.  Would you like to start a free trial?';    
    }
}